export default [
  'HOME',
  'RESTAURANTS',
  'RESTAURANT',
  'BOOKING',
  'BOOKING_2',
  'BOOKING_3',
  'BOOKING_PREORDER_MENU',
  'BOOKING_PREORDER_INTRO',
  'BOOKING_PREORDER_CART',
  'CANCEL_BOOKING',
  'TABLE_INTRO',
  'TABLE_MENU',
  'TABLE_CART',
  'TABLE_RECEIPT',
  'TAKEAWAY',
  'PAYMENT_CALLBACK'
].reduce((obj, key) => {
  obj[key] = key
  return obj
}, {})
